import { forwardRef } from "react";
import { cn } from "../../lib/cn";

export interface SafeAreaProps extends React.HTMLAttributes<HTMLDivElement> {
  edges?: "top" | "bottom" | "all";
  padding?: "none" | "sm" | "md";
}

const paddingClasses = {
  none: {
    top: "pt-[env(safe-area-inset-top)]",
    bottom: "pb-[env(safe-area-inset-bottom)]",
    all: "pt-[env(safe-area-inset-top)] pr-[env(safe-area-inset-right)] pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)]",
  },
  sm: {
    top: "px-2 pb-2 pt-[calc(0.5rem+env(safe-area-inset-top))]",
    bottom: "px-2 pt-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))]",
    all: "pt-[calc(0.5rem+env(safe-area-inset-top))] pr-[calc(0.5rem+env(safe-area-inset-right))] pb-[calc(0.5rem+env(safe-area-inset-bottom))] pl-[calc(0.5rem+env(safe-area-inset-left))]",
  },
  md: {
    top: "px-4 pb-4 pt-[calc(1rem+env(safe-area-inset-top))]",
    bottom: "px-4 pt-4 pb-[calc(1rem+env(safe-area-inset-bottom))]",
    all: "pt-[calc(1rem+env(safe-area-inset-top))] pr-[calc(1rem+env(safe-area-inset-right))] pb-[calc(1rem+env(safe-area-inset-bottom))] pl-[calc(1rem+env(safe-area-inset-left))]",
  },
} as const;

export const SafeArea = forwardRef<HTMLDivElement, SafeAreaProps>(
  ({ edges = "top", padding = "none", className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(paddingClasses[padding][edges], className)}
      {...props}
    />
  ),
);
SafeArea.displayName = "SafeArea";
